import { render, staticRenderFns } from "./CSKH-Detail.vue?vue&type=template&id=24b93439&scoped=true"
import script from "./CSKH-Detail.vue?vue&type=script&lang=js"
export * from "./CSKH-Detail.vue?vue&type=script&lang=js"
import style0 from "./CSKH-Detail.vue?vue&type=style&index=0&id=24b93439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b93439",
  null
  
)

export default component.exports